import React from "react";
import { Container, Row, Col } from "reactstrap";
import AssetInventoryTable from "./AssetInventoryTable";
import MetricTiles from "./SummaryMetrics";
import AgentStatusCharts from "./AgentStatusCharts";
import AssetTable from "./AssetTable";

const AssetManagement = () => {
  document.title = "Asset Management | Pulse";

   const pageHeadingStyle = { color: "var(--vz-body-color)" };
  const pageIconWrapStyle = {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "1px solid var(--vz-border-color)",
    background: "rgba(var(--vz-primary-rgb), 0.08)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };
  const pageIconStyle = { color: "var(--vz-primary)", fontSize: 18 };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Page Header */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex align-items-center gap-3">
                <div style={pageIconWrapStyle}>
                  <i className="ri-computer-line" style={pageIconStyle}></i>
                </div>
                <h4 className="mb-0" style={pageHeadingStyle}>
                  Asset Management
                </h4>
              </div>
            </Col>
          </Row>

          {/* Summary Metrics */}
          <MetricTiles />

          {/* Main Content - Better Layout */}
          <Row className="g-3">
            {/* Table on Bottom (Full Width) or Right */}
            <Col lg={12} xl={8} className="order-1 order-xl-1">
              <AssetInventoryTable />
            </Col>

          {/* Charts on Top (Full Width) or Left */}
            <Col lg={12} xl={4} className="order-2 order-xl-2">
              <AgentStatusCharts />
            </Col>
            
          </Row>
          <Row>
           <div>
                <AssetTable />
              </div>
         </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AssetManagement;